import styled from "styled-components";
import SectionWrapper from "../SectionWrapper";

export const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  & > div:first-child {
    flex-grow: 1;
    order: 2;
  }
  & > div:last-child {
    width: 350px;
  }

  @media (min-width: 1024px) {
    gap: 40px;
    flex-wrap: nowrap;

    & > div:first-child {
      flex-grow: 1;
      order: unset;
    }
  }
`;

export const Content = styled.div`
  width: 100%;
`;

export const Heading = styled.h1``;

export const BreadCrumbs = styled.div`
  width: 100%;
`;

export const Span = styled.span`
  text-transform: capitalize;
  font-size: 10px;
  line-height: 13px;
  padding: 0 5px;
  &.active {
    color: #fb2e86;
  }
`;

export const StyledSectionWrapper = styled(SectionWrapper)`
  padding: 50px 0;
`;
